// extracted by mini-css-extract-plugin
module.exports = {"item":"i_FX","label":"i_FY","sub-title":"i_FZ","value":"i_Fa","text":"i_Fb","icon":"i_Fc","grow":"i_Fd"};